export const WIDGET_PENDING_ACTIONS_TYPE = 'pending-actions';
